import callApi from './backendService';
import { buildQueryUrlFromObject } from '../../helper/buildQueryUrlFromObject';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

export const createTemp = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/templates`,
  body: data
});

export const getTemplatesAdmin = (formData) => callApi({
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  endpoint: `${basePath}/templates-admin?${buildQueryUrlFromObject(formData)}`
});

export const getTemplates = (formData) => callApi({
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  endpoint: `${basePath}/templates?${buildQueryUrlFromObject(formData)}`
});

export const deleteTemp = (id) => callApi({
  method: 'DELETE',
  endpoint: `${basePath}/templates/${id}`
});

export const updateTemp = (updateInfo) => callApi({
  method: 'PUT',
  endpoint: `${basePath}/templates/${updateInfo.id}`,
  body: updateInfo
});
